/* eslint-disable import/prefer-default-export */
import { InsightContentTypeStrings } from 'components/insightContent/enum/InsightContentType'
import { useAppSelector } from '../app/hooks'

export const useInsightContentData = <T = any>(
  insightContentType: InsightContentTypeStrings
): T => {
  const insightContentData = useAppSelector(
    ({ insightContent }) => insightContent?.contents?.[insightContentType]
  )
  return insightContentData
}
